import React, { useState, useRef, useEffect } from 'react';
import './SearchableSelect.css';

const SearchableSelect = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder = '请选择',
  style = {},
  onFocus,
  onBlur,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  // 过滤选项
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option => {
        const optionText = typeof option === 'object' ? option.name : option;
        return optionText.toLowerCase().includes(searchTerm.toLowerCase());
      });
      setFilteredOptions(filtered);
    }
  }, [searchTerm, options]);

  // 点击外部关闭下拉框
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // 获取显示文本
  const getDisplayText = () => {
    if (!value) return placeholder;
    const selectedOption = options.find(option => {
      const optionValue = typeof option === 'object' ? option.name : option;
      return optionValue === value;
    });
    return typeof selectedOption === 'object' ? selectedOption.name : selectedOption || value;
  };

  // 处理选择
  const handleSelect = (option) => {
    const optionValue = typeof option === 'object' ? option.name : option;
    onChange(optionValue);
    setIsOpen(false);
    setSearchTerm('');
  };

  // 处理输入框点击
  const handleInputClick = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      if (!isOpen) {
        setTimeout(() => {
          inputRef.current?.focus();
        }, 100);
      }
    }
  };

  // 处理键盘事件
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (filteredOptions.length > 0) {
        handleSelect(filteredOptions[0]);
      }
    } else if (e.key === 'Escape') {
      setIsOpen(false);
      setSearchTerm('');
    }
  };



  return (
    <div ref={containerRef} className="searchable-select-container" style={style}>
      {/* 主输入框 */}
      <div
        className={`searchable-select-input ${disabled ? 'disabled' : ''}`}
        onClick={handleInputClick}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        {getDisplayText()}
        <span className={`searchable-select-arrow ${isOpen ? 'open' : ''}`}>
          ▼
        </span>
      </div>

      {/* 下拉框 */}
      <div className="searchable-select-dropdown" style={{ display: isOpen ? 'block' : 'none' }}>
        {/* 搜索输入框 */}
        <input
          ref={inputRef}
          type="text"
          placeholder="搜索..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          className="searchable-select-search"
        />

        {/* 选项列表 */}
        <div className="searchable-select-options">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => {
              const optionValue = typeof option === 'object' ? option.name : option;
              const optionText = typeof option === 'object' ? option.name : option;
              const isSelected = optionValue === value;
              
              return (
                <div
                  key={typeof option === 'object' ? option.id || index : index}
                  className={`searchable-select-option ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleSelect(option)}
                >
                  {optionText}
                </div>
              );
            })
          ) : (
            <div className="searchable-select-no-options">
              {searchTerm ? '没有找到匹配的选项' : '暂无选项'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchableSelect; 